import React, { useState } from 'react';
import Styles from '../styles/components/NewSermonForm.module.css';

const NewSermonForm = ({ onSubmit }) => {
    const [formData, setFormData] = useState({
        title: '',
        sermon_date: '',
        bible_text: '',
        description: '',
        rumble_url: '',
        spotify_link: '',
        youtube_url: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.title || !formData.sermon_date) {
            alert('Title and Date are required.');
            return;
        }

        onSubmit(formData);

        setFormData({
            title: '',
            sermon_date: '',
            bible_text: '',
            description: '',
            rumble_url: '',
            spotify_link: '',
            youtube_url: '',
        });
    };

    return (
        <form className={Styles.formContainer} onSubmit={handleSubmit}>
            <div className={Styles.formGroup}>
                <label htmlFor="title">Title<span>*</span>:</label>
                <input
                    type="text"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="sermon_date">Date<span>*</span>:</label>
                <input
                    type="date"
                    id="sermon_date"
                    name="sermon_date"
                    value={formData.sermon_date}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="bible_text">Bible Text:</label>
                <input
                    type="text"
                    id="bible_text"
                    name="bible_text"
                    value={formData.bible_text}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="description">Description:</label>
                <textarea
                    id="description"
                    name="description"
                    rows="3"
                    value={formData.description}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="rumble_url">Rumble URL:</label>
                <input
                    type="url"
                    id="rumble_url"
                    name="rumble_url"
                    value={formData.rumble_url}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="youtube_url">YouTube URL:</label>
                <input
                    type="url"
                    id="youtube_url"
                    name="youtube_url"
                    value={formData.youtube_url}
                    onChange={handleChange}
                />
            </div>

            <div className={Styles.formGroup}>
                <label htmlFor="spotify_link">Spotify Embed:</label>
                <textarea
                    id="spotify_link"
                    name="spotify_link"
                    rows="2"
                    value={formData.spotify_link}
                    onChange={handleChange}
                />
            </div>

            <button type="submit" className={Styles.submitButton}>Add Sermon</button>
        </form>
    );
};

export default NewSermonForm;
